import PortfolioDisplay from "../Components/PortfolioDisplay";
import ClearLine from "../Components/ClearLine";
import PortfolioImage from "../Portfolios/Entities/PortfolioImage";
import Portfolio from "../Portfolios/Entities/Portfolio";
import React, {ReactNode} from "react";

export interface PageProps {
    title: string;
    image?: PortfolioImage;
    portfolio?: Portfolio;
    children: ReactNode;
}

function DisplayPortfolio(image?: PortfolioImage, portfolio?: Portfolio) {
    if (image) {
        return <PortfolioDisplay piece={image} portfolio={portfolio}/>;
    } else {
        return null;
    }
}

function Page({title, image, portfolio, children}: PageProps) {
    // Calculate dynamic padding-right based on first image's pixelWidth for tall portfolios
    let contentStyle: React.CSSProperties = {};
    if (portfolio?.piecesTallMode && portfolio.pieces.length > 0) {
        const firstImagePixelWidth = portfolio.pieces[0].pixelWidth || 0;
        contentStyle = {
            paddingRight: `calc(5% + ${firstImagePixelWidth}px)`
        };
    }

    return (
        <>
            {DisplayPortfolio(image, portfolio)}

            <div id="content" style={contentStyle}>
                <div className="infoline desktop-only"><span className="portfolio-title">{title}</span></div>

                {children}

                <ClearLine/>
            </div>
        </>
    );
}

export default Page;